module.exports = __webpack_public_path__ + "static/img/094_TO8_1769_og.ba7e0f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/094_TO8_1769_og.jpg
// module id = drqi
// module chunks = 0